import {loadStripe} from "@stripe/stripe-js";
import {STRIPE_CLIENT_KEY} from "constants.js";

export let StripePromise = loadStripe(STRIPE_CLIENT_KEY);